<template>
    <div class="background">
        <div class="left">
            <div class="mapPanel">
                <pl-lazy v-if="mapShow">
                    <main-map ref="mainmap" :lyrdata="lyrdata" :mapCtrlTools="mapCtrlTools4Use" :mapParams="mapParams"
                        :showBottomBar="false" :showSearchBar="false" :showVector="false" :showMeasure="false" :notAnnualPage="false">
                    </main-map>
                </pl-lazy>
                <div class="areaButton1" style="left: calc(100vw - 705px);top: 20px;" v-if="!showVectorTileLayer">显示拍摄时间</div>
                <div class="areaButton1-s" style="left: calc(100vw - 705px);top: 20px;" v-if="showVectorTileLayer" @click="showVectorLayer()">{{showImageTime}}</div>
                <div class="redHint">
                    <div class="curMk">当前图源：{{ curLayerName }}</div>
                    <div class="mkTips">提示：图源仅作示意，支持放大至12级，不计流量。红色区域因拍摄期间有云，已使用往期切片影像替换。</div>
                </div>
            </div>
        </div>
        <!-- 第一步 -->
        <div class="right" v-if="page==1">
            <div class="rightText1">购买图源包年</div>
            <div class="step">
                <div class="circle1">
                    <div class="rightText2">1</div>
                </div>
                <div class="rightText3">选择区域</div>
                <div class="rightLine1"></div>
                <div class="circle2">
                    <div class="rightText4">2</div>
                </div>
                <div class="rightText5">选择图源</div>
                <div class="rightLine1" style="left: 292px;background: rgba(0,0,0,0.15);"></div>
                <div class="circle2" style="left: 384px;">
                    <div class="rightText4">3</div>
                </div>
                <div class="rightText5" style="left: 416px;">提交订单</div>
            </div>
            <div class="rightLine2"></div>
            <!-- 搜索框 -->
            <searchInput class="searchInput" ref="searchInput" v-if="searchType"></searchInput>
            <searchPoint class="searchCtn" ref="searchPoint" v-if="!searchType"></searchPoint>
            <img src="../../../assets/dataPack/AnnualPurchase/切换.png" alt="" class="searchInputIcon1" @click="searchType=!searchType">
            <div class="selTab">
                <div :class="curPlaceTab == 1 ? 'selTabCtn1Sel' : 'selTabCtn1'"  @click="curPlaceTab=1">
                    <img src="../../../assets/dataPack/AnnualPurchase/上传矢量蓝.png" alt="" class="selTabCtn1Img" v-if="curPlaceTab==1">
                    <img src="../../../assets/dataPack/AnnualPurchase/上传矢量黑.png" alt="" class="selTabCtn1Img" v-if="curPlaceTab!=1">
                    <div :class="curPlaceTab == 1 ? 'selTabCtn1TextSel' : 'selTabCtn1Text'">上传矢量</div>
                </div>
                <div :class="curPlaceTab == 2 ? 'selTabCtn1Sel' : 'selTabCtn1'"  @click="curPlaceTab=2" style="width:120px;margin-left: 30px;">
                    <img src="../../../assets/dataPack/AnnualPurchase/选择行政区域蓝.png" alt="" class="selTabCtn1Img" v-if="curPlaceTab==2">
                    <img src="../../../assets/dataPack/AnnualPurchase/选择行政区域黑.png" alt="" class="selTabCtn1Img" v-if="curPlaceTab!=2">
                    <div :class="curPlaceTab == 2 ? 'selTabCtn1TextSel' : 'selTabCtn1Text'">选择行政区域</div>
                </div>
                <div :class="curPlaceTab == 3 ? 'selTabCtn1Sel' : 'selTabCtn1'" @click="curPlaceTab=3" style="width:88px;margin-left: 30px;">
                    <img src="../../../assets/dataPack/AnnualPurchase/绘制区域蓝.png" alt="" class="selTabCtn1Img" v-if="curPlaceTab==3">
                    <img src="../../../assets/dataPack/AnnualPurchase/绘制区域黑.png" alt="" class="selTabCtn1Img" v-if="curPlaceTab!=3">
                    <div :class="curPlaceTab == 3 ? 'selTabCtn1TextSel' : 'selTabCtn1Text'">绘制区域</div>
                </div>
                <div :class="curPlaceTab == 4 ? 'selTabCtn1Sel' : 'selTabCtn1'"  @click="curPlaceTab=4" style="width:120px;margin-left: 30px;">
                    <img src="../../../assets/dataPack/AnnualPurchase/输入区域坐标蓝.png" alt="" class="selTabCtn1Img" v-if="curPlaceTab==4">
                    <img src="../../../assets/dataPack/AnnualPurchase/输入区域坐标黑.png" alt="" class="selTabCtn1Img" v-if="curPlaceTab!=4">
                    <div :class="curPlaceTab == 4 ? 'selTabCtn1TextSel' : 'selTabCtn1Text'">输入区域坐标</div>
                </div>
            </div>
            <div v-if="curPlaceTab == 1" class="tab1">
                <a-upload-dragger class="tab1Input" :accept="'.kml,.kmz,.zip'" name="file" :multiple="false" :customRequest="customRequest"
                    :fileList="fileList" @change="handleChangeFile">
                    <p class="ant-upload-drag-icon">
                        <a-icon type="inbox" />
                    </p>
                    <p class="ant-upload-text">点击或将文件拖拽到这里上传</p>
                    <p class="ant-upload-hint">支持扩展名：.kml .kmz .zip（需包含.shp和.prj）</p>
                </a-upload-dragger>
                <div class="tab1Btn" @click="cancelArea()">
                    <img src="../../../assets/dataPack/AnnualPurchase/清除.png" alt="" class="tab1BtnIcon">
                    <div class="tab1BtnText">清除</div>
                </div>
                <div class="tab1Tip">提示：上传矢量的最小面积不得低于25km²，面积不足将自动扩充至25km²。</div>
            </div>
            <div v-if="curPlaceTab == 2" class="tab1" style="height: 126px;">
                <a-radio-group v-model="tab2Sel" class="tab2Radio">
                    <a-radio :value="1">选择省/市/县区域</a-radio>
                    <a-radio :value="2" style="margin-left: 64px;">选择全国区域</a-radio>
                </a-radio-group>
                <div v-if="tab2Sel==1">
                    <a-select class="tab2Select" v-model="chinaProvinceNow" placeholder="省份">
                        <a-select-option v-for="item in chinaProvinceItems" :key="item.areaId">
                            {{ item.areaName }}
                        </a-select-option>
                    </a-select>
                    <a-select class="tab2Select" v-model="chinaCityNow" placeholder="城市" style="margin-left: 24px;">
                        <a-select-option v-for="item in chinaCityItems" :key="item.areaId">
                            {{ item.areaName }}
                        </a-select-option>
                    </a-select>
                    <a-select class="tab2Select" v-model="chinaCountyNow" placeholder="区县" style="margin-left: 24px;">
                        <a-select-option v-for="item in chinaCountyItems" :key="item.areaId">
                            {{ item.areaName }}
                        </a-select-option>
                    </a-select>
                    <div class="tab1Btn" style="float: right;" @click="cancelArea()">
                        <img src="../../../assets/dataPack/AnnualPurchase/清除.png" alt="" class="tab1BtnIcon">
                        <div class="tab1BtnText">清除</div>
                    </div>
                </div>
                <div v-if="tab2Sel==2">
                    <div class="tab2Text1">请咨询商务经理购买：0431-86008580 </div>
                </div>
            </div>
            <div v-if="curPlaceTab == 3" class="tab1" style="height: 161px;">
                <img src="../../../assets/dataPack/AnnualPurchase/正方形.png" alt="" class="selCtn2Img" @click="shapeSel=1;" v-if="shapeSel!=1">
                <img src="../../../assets/dataPack/AnnualPurchase/正方形选中.png" alt="" class="selCtn2Img" v-if="shapeSel==1">
                <img src="../../../assets/dataPack/AnnualPurchase/矩形.png" alt="" class="selCtn2Img"  @click="shapeSel=2;" v-if="shapeSel!=2" style="left:140px;">
                <img src="../../../assets/dataPack/AnnualPurchase/矩形选中.png" alt="" class="selCtn2Img" v-if="shapeSel==2" style="left: 140px;">
                <img src="../../../assets/dataPack/AnnualPurchase/多边形.png" alt="" class="selCtn2Img"  @click="shapeSel=3;" v-if="shapeSel!=3" style="left: 280px;">
                <img src="../../../assets/dataPack/AnnualPurchase/多边形选中.png" alt="" class="selCtn2Img" v-if="shapeSel==3" style="left: 280px;">
                <div class="selCtn2Text1">25k㎡矩形</div>
                <div class="selCtn2Text1" style="left: 168px;width: 44px;">矩形</div>
                <div class="selCtn2Text1" style="left: 301px;width: 58px;">多边形</div>
                <div class="selTabCtn2Btn1" style="top: 24px;" @click="cancelArea()">
                    <img src="../../../assets/dataPack/AnnualPurchase/清除.png" alt="" class="selTabCtn2Btn1Img">
                    <div class="selTabCtn2Btn1TextHover">清除</div>
                </div>
                <div class="selTabCtn2Text2" style="top: 136px;">提示：选择矢量的最小面积不得低于25km²。</div>
            </div>
            <div v-if="curPlaceTab == 4" class="tab1" style="height: 138px;">
                <div class="selCoordTab">
                    <div class="selCoordCtn1" @click="coordTab=1">
                        <div :class="coordTab == 1 ? 'selCoordTextSel' : 'selCoordText'">中心点坐标</div>
                        <div class="selCoordDivider"></div>
                    </div>
                    <div class="selCoordCtn1" @click="coordTab=2">
                        <div :class="coordTab == 2 ? 'selCoordTextSel' : 'selCoordText'">角点坐标</div>
                        <div class="selCoordDivider" style="width: 2px;"></div>
                    </div>
                    <div class="selCoordCtn1" @click="coordTab=3">
                        <div :class="coordTab == 3 ? 'selCoordTextSel' : 'selCoordText'">节点坐标</div>
                    </div>
                </div>
                <div class="coordCtn">
                    <!-- 中心点坐标栏 -->
                    <div class="quarterPart" v-if="coordTab==1">
                        <!-- 中心点经度 -->
                        <div class="inputTitle" style="left: 12px;">中心点经度：</div>
                        <div class="inputCtn">
                            <input type="number" v-model="centerLon" class="searchInput1">
                        </div>
                        <img src="../../../assets/dataPack/AnnualPurchase/转换.png" alt="" class="searchInput1Icon1" @click="centerLonTrans=!centerLonTrans">
                        <div class="transCtn" v-if="centerLonTrans" style="z-index: 1;">
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="centerLons[0]" type="number" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">度
                            </div>
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="centerLons[1]" type="number" min="0" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">分
                            </div>
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="centerLons[2]" type="number" min="0" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">秒
                            </div>
                        </div>
                        <!-- 中心点纬度 -->
                        <div class="inputTitle" style="left: 225px;">中心点纬度：</div>
                        <div class="inputCtn" style="left: 305px;">
                            <input type="number" v-model="centerLat" class="searchInput1">
                        </div>
                        <img src="../../../assets/dataPack/AnnualPurchase/转换.png" alt="" style="left: 393px;" class="searchInput1Icon1" @click="centerLatTrans=!centerLatTrans">
                        <div class="transCtn" style="left: 285px;z-index: 1;" v-if="centerLatTrans">
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="centerLats[0]" type="number" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">度
                            </div>
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="centerLats[1]" type="number" min="0" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">分
                            </div>
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="centerLats[2]" type="number" min="0" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">秒
                            </div>
                        </div>
                        <!-- 距中心点长度 -->
                        <div class="inputTitle" style="top: 38px;">距中心点长度：</div>
                        <div class="inputCtn" style="top: 37px;">
                            <input type="number" v-model="lengthKM" class="searchInput1">
                        </div>
                        <div class="inputTitle" style="left: 180px;top: 38px;">km</div>
                        <!-- 距中心点宽度 -->
                        <div class="inputTitle" style="top: 38px;left: 213px;">距中心点宽度：</div>
                        <div class="inputCtn" style="top: 37px;left: 305px;">
                            <input type="number" v-model="widthKM" class="searchInput1">
                        </div>
                        <div class="inputTitle" style="left: 393px;top: 38px;">km</div>
                    </div>
                    <!-- 角点坐标栏 -->
                    <div class="quarterPart" v-if="coordTab==2">
                        <!-- 左上经度 -->
                        <div class="inputTitle" style="left: 24px;">左上经度：</div>
                        <div class="inputCtn">
                            <input type="number" v-model="minLon" class="searchInput1">
                        </div>
                        <img src="../../../assets/dataPack/AnnualPurchase/转换.png" alt="" class="searchInput1Icon1" @click="minLonTrans=!minLonTrans">
                        <div class="transCtn" v-if="minLonTrans" style="z-index: 1;">
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="minLons[0]" type="number" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">度
                            </div>
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="minLons[1]" type="number" min="0" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">分
                            </div>
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="minLons[2]" type="number" min="0" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">秒
                            </div>
                        </div>
                        <!-- 左上纬度 -->
                        <div class="inputTitle" style="left: 237px;">左上纬度：</div>
                        <div class="inputCtn"  style="left: 305px;">
                            <input type="number" v-model="maxLat" class="searchInput1">
                        </div>
                        <img src="../../../assets/dataPack/AnnualPurchase/转换.png" alt="" style="left: 393px;" class="searchInput1Icon1" @click="maxLatTrans=!maxLatTrans">
                        <div class="transCtn" style="left: 285px;z-index: 1;" v-if="maxLatTrans">
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="maxLats[0]" type="number" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">度
                            </div>
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="maxLats[1]" type="number" min="0" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">分
                            </div>
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="maxLats[2]" type="number" min="0" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">秒
                            </div>
                        </div>
                        <!-- 右下经度 -->
                        <div class="inputTitle" style="left: 24px;top: 38px;">右下经度：</div>
                        <div class="inputCtn" style="top: 37px;">
                            <input type="number" v-model="maxLon" class="searchInput1">
                        </div>
                        <img src="../../../assets/dataPack/AnnualPurchase/转换.png" alt="" style="top: 41px;" class="searchInput1Icon1" @click="maxLonTrans=!maxLonTrans">
                        <div class="transCtn" v-if="maxLonTrans" style="z-index: 1;">
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="maxLons[0]" type="number" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">度
                            </div>
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="maxLons[1]" type="number" min="0" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">分
                            </div>
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="maxLons[2]" type="number" min="0" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">秒
                            </div>
                        </div>
                        <!-- 右下纬度 -->
                        <div class="inputTitle" style="left: 237px;top: 38px;">右下纬度：</div>
                        <div class="inputCtn"  style="left: 305px;top: 37px;">
                            <input type="number" v-model="minLat" class="searchInput1">
                        </div>
                        <img src="../../../assets/dataPack/AnnualPurchase/转换.png" alt="" style="left: 393px;top: 41px;" class="searchInput1Icon1" @click="minLatTrans=!minLatTrans">
                        <div class="transCtn" style="left: 285px;z-index: 1;" v-if="minLatTrans">
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="minLat[0]" type="number" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">度
                            </div>
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="minLat[1]" type="number" min="0" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">分
                            </div>
                            <div style="width:33%;display:flex;align-items: center;">
                                <input v-model="minLat[2]" type="number" min="0" step="1" style="width:65%;border:0px;outline:none;text-align:center;background: rgba(0,0,0,0);color: #3a3a3a;">秒
                            </div>
                        </div>
                    </div>
                    <!-- 节点坐标栏 -->
                    <div v-if="coordTab==3" class="inputCtn2">
                        <textarea type="text" v-model="coordString" class="searchInput2" placeholder="节点坐标的经纬度用空格分隔，多个坐标用英文逗号分隔。例：125.39 43.98,116.39 39.92,121.50 31.24"></textarea>
                    </div>
                    <div class="selCtn2SelBtn1Hover" @click="searchCoord()">
                        <img src="../../../assets/dataPack/AnnualPurchase/白搜索.png" alt="" class="selCtn2SelBtn1Img" >
                        <div class="selTabCtn2Btn1Text">查询</div>
                    </div>
                    <div class="selTabCtn2Btn1" @click="cleardrawCoords()">
                        <img src="../../../assets/dataPack/AnnualPurchase/清除.png" alt="" class="selTabCtn2Btn1Img">
                        <div class="selTabCtn2Btn1TextHover">清除</div>
                    </div>
                    <div class="selTabCtn2Text2">提示：选择矢量的最小面积不得低于25km²。</div>
                </div>
            </div>
            <div class="rightText6">
                <div class="rightText7" id="itemTextId">区域名称</div>
                <div class="rightText8" v-if="countyNameResult==''">暂未选择区域</div>
                <div class="rightText8" v-if="countyNameResult!=''&&curPlaceTab==2">{{countyNameResult}}</div>
                <input type="text" class="areaNameInput" v-if="countyNameResult!=''&&curPlaceTab!=2" v-model="customizeName" id="areaNameInputId" @change="customizeNameAdd()" maxlength="30">
            </div>
            <div class="rightText6" style="margin-top: 16px;">
                <div class="rightText7">区域面积</div>
                <div class="rightText8" v-if="countyNameResult==''">暂未选择区域</div>
                <div class="rightText8" v-if="countyNameResult!=''">
                    <span v-if="countyAreaResult>=25">{{countyAreaResult.toFixed(3)}}km²</span>
                    <span v-else-if="countyAreaResult!=-1" style="color: rgba(255, 0, 0, 1);">{{countyAreaResult.toFixed(3)}}km²
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  当前区域面积不足25km²，请调整区域后下单。
                    </span>
                    <!-- <span v-else style="color: rgba(255, 0, 0, 1);">当前区域面积未知，请调整区域后下单。
                    </span> -->
                </div>
            </div>
            <img src="../../../assets/dataPack/purchaseData/联系商务经理.png" alt="" class="rightIcon1" @click="$router.push('/onlineService/Home')">
            <div class="rightLine3"></div>
            <div :class="customizeName.length>0&&countyNameResult!=''&&countyAreaResult>=25 ? 'rightBtn-s' : 'rightBtn'" @click="goStep2">下一步</div>
        </div>
        <!-- 第二步 -->
        <div class="right" v-if="page==2">
            <div class="rightText1">购买图源包年</div>
            <div class="step">
                <div class="step1Head" @click="page = 1;tab2Sel=1"><!--  @click="clearStep2()" -->
                    <img src="../../../assets/dataPack/AnnualPurchase/对号.png" alt="" class="step2Icon">
                    <div class="rightText5" style="left: 32px;">选择区域</div>
                </div>
                <div class="rightLine1"></div>
                <div class="circle1" style="left: 192px;">
                    <div class="rightText2">2</div>
                </div>
                <div class="rightText3" style="left: 224px;">选择图源</div>
                <div class="rightLine1" style="left: 292px;background: rgba(0,0,0,0.15);"></div>
                <div class="circle2" style="left: 384px;">
                    <div class="rightText4">3</div>
                </div>
                <div class="rightText5" style="left: 416px;">提交订单</div>
            </div>
            <div class="rightLine2"></div>
            <div class="step2ScrollCtn">
            <div class="step2Area">
                <div class="step2AreaText1">区域名称</div>
                <div class="rightText8" v-if="countyNameResult==''">暂未选择区域</div>
                <div class="rightText8" v-if="countyNameResult!=''&&curPlaceTab==2">{{countyNameResult}}</div>
                <input type="text" class="areaNameInput" v-if="countyNameResult!=''&&curPlaceTab!=2" v-model="customizeName" id="areaNameInputId" @change="customizeNameAdd()" maxlength="30">
                <div class="step2AreaText1" style="top: 38px;">区域面积</div>
                <div class="rightText8" v-if="countyNameResult!=''" style="top: 38px;">{{countyAreaResult.toFixed(3)}}km²</div>
                <div class="step2AreaText2" @click="clearStep2()">重新选择区域</div>
            </div>
            <div class="step2Text1">请选择图源（支持多选）</div>
            <div class="step2Ctn">
                <div :class="picSel == 1 ? 'stepCtnBtn1' : 'stepCtnBtn1-s'" @click="switchPicSel(1)">基础图源 ￥{{ basicPrice }}/km²/年
                    <div class="stepCtnBtn1Line" v-if="picSel==1"></div>
                </div>
                <div :class="picSel == 2 ? 'stepCtnBtn1' : 'stepCtnBtn1-s'" @click="switchPicSel(2)" style="left:276px">高级图源 ￥{{ premiumPrice }}/km²/年
                    <div class="stepCtnBtn1Line" v-if="picSel==2"></div>
                </div>
            </div>
            <div class="step2ListCtn">
                <div v-for="(series, seriesIndex) in dataList" :key="seriesIndex">
                    <div class="step2ListHead">
                        <div class="step2LixtText1">{{ series.name }} &nbsp;&nbsp;(已选{{ getSeriesSelectedCount(seriesIndex) }})</div>
                        <img src="../../../assets/dataPack/AnnualPurchase/展开.png" alt="" v-if="series.isExpanded" class="step2ListIcon1" @click="toggleSeries(seriesIndex)">
                        <img src="../../../assets/dataPack/AnnualPurchase/收起.png" alt="" v-if="!series.isExpanded" class="step2ListIcon2" @click="toggleSeries(seriesIndex)">
                    </div>
                    <div v-if="series.isExpanded">
                        <div :class="isSelected(seriesIndex, itemIndex) ? 'step2ListTable-s' : 'step2ListTable'" v-for="(item, itemIndex) in series.list" :key="itemIndex">
                            <div class="step2LixtText2">{{ item.name }}</div>
                            <div class="step2LixtText3">{{ item.imageGsd }}</div>
                            <div class="step2LixtText4">￥{{ item.price }}</div>
                            <img src="../../../assets/dataPack/purchaseData/对号.png" alt="" class="step2ListIcon3" @click="toggleSelect(seriesIndex, itemIndex)" v-if="isSelected(seriesIndex, itemIndex)">
                            <img src="../../../assets/dataPack/AnnualPurchase/灰色对号.png" alt="" class="step2ListIcon3" @click="toggleSelect(seriesIndex, itemIndex)" v-if="!isSelected(seriesIndex, itemIndex)">
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <img src="../../../assets/dataPack/purchaseData/联系商务经理.png" alt="" class="rightIcon1" @click="$router.push('/onlineService/Home')">
            <div class="rightLine3"></div>
            <div class="step2Text2">共选择{{ selectedCount }}个图源</div>
            <div class="step2Text3">共计：<span style="color: rgba(255, 0, 0, 1);font-weight: 500;">￥{{ totalPrice.toFixed(2) }}</span></div>
            <div :class="selectedCount>0 ? 'rightBtn-s' : 'rightBtn'" @click="submitAnnualOrder">下一步</div>
        </div>
        <!-- 认证身份弹窗 -->
        <div class="shadow" v-if="shadowTip">
            <div class="shadowWhite">
                <img src="../../../assets/calendar/日历关闭.png" alt="" class="shadowClose" @click="shadowTip=false">
                <div class="shadowText1">用户身份认证</div>
                <div class="shadowText2">根据国家地理信息安全与保密相关规定，为规范数据使用，保障您的合法权益，购买和使用卫星遥感数据需完成<span style="font-weight: 600;">机构企业用户</span>/<span style="font-weight: 600;">教育科研用户</span>认证。（认证后可享受会员价格）</div>
                <div class="shadowSel" @click="jumpWithPermission('可游客','/store/ApplyGovernmentMember','/rskit')">
                    <img src="../../../assets/dataPack/企业用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
                </div>
                <div class="shadowSel" @click="jumpWithPermission('可游客','/store/OpenEducationalCertification','/rskit')" style="left: 400px;">
                    <img src="../../../assets/dataPack/教育用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
                </div>
            </div>
        </div>
        <!-- 机构企业：授权委托书（component 化） -->
        <PurchaseAuthLetterDialog
            :visible.sync="authLetterModalVisible"
            :mode="authLetterModalMode"
            :reject-reason="authorizationLetterRejectReason"
            :user-identity-review-status="userIdentityReviewStatus"
            @success="onAuthLetterSuccess"
            @fail="onAuthLetterFail"
        />
    </div>
</template>
<script>
// 0免费体验图源系列、1全国高质量一张图系列、2全国季度一张图系列、3全球一张图（基础版）系列、4全球一张图（高级版）系列（跟实验室一致，需同步维护）
const folderMapping = {
  '0':'免费体验图源系列',
  '1':'全国年度一张图系列',
  '2':'全国双月一张图系列',
  '3':'全国季度一张图系列',
  '4':'全国半年精选图系列',
  '5':'全球一张图（基础版）系列',
  '6':'全球一张图（高级版）系列'
}
import { rootUrl } from '@/globalConfig'
import searchInput from './searchInput.vue'
import searchPoint from './searchPoint.vue'
import PurchaseAuthLetterDialog from '@/components/PurchaseAuthLetterDialog.vue'
import { checkUserCert } from '@/utils/userCertCheck'

import MainMap from '@/components/Maps/MainMap'
import { Vector,Tile } from 'ol/layer';
import { Polygon, LineString, MultiPolygon,MultiLineString,Point } from 'ol/geom'
import Feature from 'ol/Feature';
import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
import VectorTileLayer from 'ol/layer/VectorTile';
import { VectorTile } from 'ol/source';
import { MVT, GeoJSON } from 'ol/format';
import { Fill, Stroke, Style, Text } from 'ol/style';
import * as turf from "turf";
import { getCenter } from 'ol/extent'
import { toLonLat } from 'ol/proj'
import booleanContains from '@turf/boolean-contains'
import WKT from "terraformer-wkt-parser"
import flatten from "@turf/flatten";
export default {
    components: {
        searchInput,
        searchPoint,
        MainMap,
        PurchaseAuthLetterDialog,
    },
    data() {
        return {
            page:1,
            keyword:'',
            searchType:true,
            pointLon:['','',''],//度分秒的经度
            pointLat:['','',''],//度分秒的纬度
            curPlaceTab:1,
            fileList:[],
            tab2Sel:1,
            chinaProvinceItems:[],
            chinaCityItems: [],
            chinaCountyItems:[],
            chinaProvinceNow:undefined,
            chinaCityNow:undefined,
            chinaCountyNow:undefined,
            // 输入区域坐标相关参数
            coordTab:1,
            centerLon:'',
            centerLat:'',
            centerLons:['','',''],
            centerLats:['','',''],
            centerLonTrans:false,
            centerLatTrans:false,
            lengthKM:'',
            widthKM:'',
            minLon:'',
            minLat:'',
            maxLon:'',
            maxLat:'',
            minLons:['','',''],
            minLats:['','',''],
            maxLons:['','',''],
            maxLats:['','',''],
            minLonTrans:false,
            minLatTrans:false,
            maxLonTrans:false,
            maxLatTrans:false,
            coordString:'',
            shapeSel:0,//25km²正方形1 矩形2 多边形3
            countyNameResult:'',
            customizeName:'',
            countyAreaResult:-1,
            //图源选择
            picSel:1,
            basicPrice:3,
            premiumPrice:10,
            basicDataList:[],
            premiumDataList:[],
            dataList:[],
            selectedBasicItems: [],
            selectedPremiumItems: [],
            regionAreaId:null,
            regionShape:'',

            lyrdata: [],
            // lyrdata: [{
            //     lyrType:"Tile",
            //     srcType:"XYZ",
            //     // mUrl:`https://api.jl1mall.com/getMap/{z}/{x}/{-y}?mk=2d9bf902749f1630bc25fc720ba7c29f&tk=0073bef5c4266498b8f18225fe63a3fa&vf=0`,
            //     mUrl:`https://api.jl1mall.com/getTile/{z}/{x}/{-y}?mk=2d9bf902749f1630bc25fc720ba7c29f&tk=b9ae773d2fc3c91791e9edb2ba114911&vf=0`,
            //     mTitle:'底图',
            //     mName:'底图',
            //     // mExtent:v.extent.split(','),
            //     mVisible:true
            // },
            // {
            //     lyrType:"lVector",
            //     srcType:"Vector",
            //     mUrl:'',
            //     mTitle:"边框",
            //     mName:"边框",
            //     mVisible:true
            // },],
            mapCtrlTools4Use: [2],
            mapParams: {
                projection:'EPSG:3857', //注意：必须加上此投影才能显示地图，目前有效的是4326和3857，而4490暂未生效
                center:[108.29883, 35.72902], //地图初始化时的中心坐标【基于4326坐标系】
                // center:[142.85524, 43.61710], //地图初始化时的中心坐标【基于4326坐标系】
                // mExtent:[120.45536,35.55856,139.36943,44.78707], //左下点-右上点
                minZoom:1, //可以缩小的最小级别；若此处未定义，地图接收到undefined则表示不受限制
                maxZoom:12, //可以放大的最大级别；若此处未定义，地图接收到undefined则表示不受限制
                zoom:4, //地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
            },
            loadGisMapRunOver: false,//用于判断mainmap是否加载完成

            // //是否可以查询绘制区域
            // canQueryArea:false,
            // //是否可以查询上传矢量
            // canQueryVector:false,

            showVectorTileLayer:false,
            vectorTileLayer:null,
            foreanHint:false,
            showImageTime: '显示拍摄时间',

            tk:'',
            sk:'',
            mkList: [],
            // tileBaseUrl:'http://10.200.28.23:9090',
            tileBaseUrl: 'https://api.jl1mall.com',
            // tileBaseUrl:'https://mt.jl1mall.com',
            mapShow: false,
            curLayerName: '',
            curmk:'',
            shadowTip: false,
            authLetterModalVisible: false,
            authLetterModalMode: "not_upload",
            authorizationLetterRejectReason: "",
            // 与 jl1store_front 对齐：0~13 状态码，由 userCertCheck utility 通过 onStatus 回调写入
            // component 内部用此值计算 isEnterprise
            userIdentityReviewStatus: null,
            // 是否免费敏感区域用户：getUserSensitiveConfig 返回 userOrgType 为 I类/II类 时为 1，其余为 0；默认 0（接口未返回前/失败均按 0）
            free_sensitive: 0,
        }
    },
    mounted() {
        this.getTk();
        this.fetchUserSensitiveConfig()

        this.axios.get('/accessapi/searchService/Area/id=-1').then((res) => {
            this.chinaProvinceItems = res.data.data
        })

        bus.$off('buyDrawFinish')
        bus.$on('buyDrawFinish', () => {
            let features = this.$refs.mainmap.source.getFeatures()
            let features_4326 = this.$refs.mainmap.featuresTo84MultiPolygon(features)
            let geojson =features_4326.geometry

            let regionShp = WKT.convert(geojson)
            this.regionShape = regionShp
            this.regionAreaId = null
            let formdata = new FormData()
            formdata.append('wkt',regionShp)
            this.axios.post('/map_service_back/program/getArea', formdata).then((res) => {
                if (res.data.code==200) {
                    this.countyAreaResult = this.normalizeCountyArea(Math.abs(res.data.area-25)<0.1 ? 25 : res.data.area)
                }
            })

            let formdataRegion = new FormData()
            formdataRegion.append("shape",regionShp)
            this.axios
            .post("/map_service_back/vectorLibrary/getRegion", formdataRegion)
            .then(res => {
                let result = res.data.data
                result.sort(function(a,b) {
                    return a.area_level-b.area_level
                })
                this.countyNameResult=''
                result.forEach(r => {
                    this.countyNameResult=this.countyNameResult+r.area_name
                })
                this.countyNameResult = this.countyNameResult + '（自选区域）'
                this.customizeName=this.countyNameResult
            })
        })
        this.restoreAnnualPurchaseState()

        setTimeout(() => {
            this.loadVectorTile()
        }, 1000);
    },
    watch:{
        chinaProvinceNow(){
            this.chinaCityNow = undefined
            this.chinaCountyNow = undefined
            this.chinaCityItems = []
            this.chinaCountyItems = []
            if (this.chinaProvinceNow !== undefined){
                this.axios.get('/accessapi/searchService/Area/id=' + this.chinaProvinceNow).then((res) => {
                    this.chinaCityItems = res.data.data
                })
                //  添加到边框中并计算面积
                let curProvince=this.chinaProvinceItems.filter(i=>{
                    return i.areaId==this.chinaProvinceNow
                })
                this.regionAreaId = curProvince[0].areaId || null
                this.countyNameResult = curProvince[0].areaName
                this.customizeName=this.countyNameResult
                let geoJson=JSON.parse(curProvince[0].areaGeojson)
                this.regionShape = WKT.convert(geoJson)
                bus.$emit('showUploadVector', geoJson)

                let wkt=WKT.convert(geoJson)
                let formdata = new FormData()
                formdata.append('wkt',wkt)
                this.axios.post('/map_service_back/program/getArea', formdata).then((res) => {
                    if (res.data.code==200) {
                        this.countyAreaResult = this.normalizeCountyArea(res.data.area)
                    }
                })
            }
        },
        chinaCityNow() {
            this.chinaCountyNow = undefined
            this.chinaCountyItems = []
            if (this.chinaCityNow !== undefined) {
                this.axios.get('/accessapi/searchService/Area/id=' + this.chinaCityNow).then((res) => {
                    this.chinaCountyItems = res.data.data
                })
                // 添加到边框中并计算面积
                let curCity = this.chinaCityItems.filter(i => {
                    return i.areaId==this.chinaCityNow
                })
                this.regionAreaId = curCity[0].areaId || null
                this.countyNameResult = curCity[0].areaName
                this.customizeName=this.countyNameResult
                let geoJson = JSON.parse(curCity[0].areaGeojson)
                this.regionShape = WKT.convert(geoJson)
                bus.$emit('showUploadVector', geoJson)

                let wkt=WKT.convert(geoJson)
                let formdata = new FormData()
                formdata.append('wkt',wkt)
                this.axios.post('/map_service_back/program/getArea', formdata).then((res) => {
                    if (res.data.code==200) {
                        this.countyAreaResult = this.normalizeCountyArea(res.data.area)
                    }
                })
            }
        },
        chinaCountyNow() {
            if (this.chinaCountyNow !== undefined) {
                // 添加到边框中并计算面积
                let curCounty = this.chinaCountyItems.filter(i => {
                    return i.areaId==this.chinaCountyNow
                })
                this.regionAreaId = curCounty[0].areaId || null
                this.countyNameResult = curCounty[0].areaName
                this.customizeName=this.countyNameResult
                let geoJson = JSON.parse(curCounty[0].areaGeojson)
                this.regionShape = WKT.convert(geoJson)
                bus.$emit('showUploadVector', geoJson)

                let wkt=WKT.convert(geoJson)
                let formdata = new FormData()
                formdata.append('wkt',wkt)
                this.axios.post('/map_service_back/program/getArea', formdata).then((res) => {
                    if (res.data.code==200) {
                        this.countyAreaResult = this.normalizeCountyArea(res.data.area)
                    }
                })
            }
        },
        customizeName(newVal){
            if(this.countyNameResult!=''&&this.curPlaceTab!=2){
                if (newVal.length <= 0) {
                    this.$nextTick(() => {
                        let areaNameInputId = document.getElementById('areaNameInputId')
                        let itemTextId = document.getElementById('itemTextId')
                        if (areaNameInputId && itemTextId) {
                            areaNameInputId.style.borderBottom = '1px solid #F35656'
                            itemTextId.style.color = '#F35656'
                        }
                    });
                } else {
                    this.$nextTick(() => {
                        let areaNameInputId = document.getElementById('areaNameInputId')
                        let itemTextId = document.getElementById('itemTextId')
                        if (areaNameInputId&&itemTextId) {
                            areaNameInputId.style.borderBottom = '1px solid rgba(215,215,215,0.4)'
                            itemTextId.style.color = '#000'
                        }
                    });
                }
            }
        },
        curPlaceTab(){
            this.countyNameResult = ''
            this.countyAreaResult = -1
            let itemTextId = document.getElementById('itemTextId')
            itemTextId.style.color='#000'
        },
        shapeSel(newVal){
            // this.canQueryArea=false
            // this.canQueryVector=false
            // this.showCountyNameResult = false
            bus.$emit('clean')
            if(newVal==1){
                this.$refs.mainmap.drawArea()
            }
            else if(newVal==2){
                bus.$emit('buyArea','rec')
            }
            else if(newVal==3){
                bus.$emit('buyArea','area')
            }

        },
        '$route'() {
            this.applyPicSelFromRoute();
        },
    },
    created() {
        this.applyPicSelFromRoute();
    },
    computed: {
        selectedCount() {
            return this.selectedBasicItems.length + this.selectedPremiumItems.length;
        },
        // 计算总价格
        totalPrice() {
            return this.basicTotalPrice + this.premiumTotalPrice;
        },
        basicTotalPrice() {
            return this.selectedBasicItems.reduce((total, selectedItem) => total + selectedItem.item.price, 0);
        },
        premiumTotalPrice() {
            return this.selectedPremiumItems.reduce((total, selectedItem) => total + selectedItem.item.price, 0);
        },
    },
    methods:{
        getKey() {
            return localStorage.getItem("token");
        },
        // 查询当前用户敏感区域权限与机构类型；仅 userOrgType 为 I类/II类 时 free_sensitive=1，其余=0。
        // 失败、未登录、code!=200 均静默按 0 处理，不阻塞主流程。
        fetchUserSensitiveConfig() {
            let token = this.getKey();
            if (!token) {
                this.free_sensitive = 0;
                return;
            }
            this.axios.get('/accessapi/requirement/getUserSensitiveConfig', {
                headers: { Authorization: 'Bearer ' + token }
            }).then((res) => {
                let ok = Number(res.data.status) === 200 && res.data.message === 'success';
                if (!ok) {
                    ok = Number(res.data.code) === 200 && res.data.msg === 'success';
                }
                if (!ok) {
                    this.free_sensitive = 0;
                    return;
                }
                let orgType = res.data.data ? res.data.data.userOrgType : '';
                this.free_sensitive = (orgType === 'I类' || orgType === 'II类') ? 1 : 0;
            }).catch(() => {
                this.free_sensitive = 0;
            });
        },
        normalizeCountyArea(value) {
            const area = Number(value);
            if (Number.isNaN(area)) {
                return 0;
            }
            return Number(area.toFixed(3));
        },
        jumpWithPermission(type,path,fromUrl){
            //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
            //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
            let loginUserId=localStorage.getItem('userId');//是否已登录
            let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
            if(type=='可游客'){
                if(fromUrl){
                    window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                    window.open(rootUrl+path,"_self")
                }
            }else if(type=='仅登录'){
                //已登录
                if(loginUserId){
                    if(fromUrl){
                        window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+path,"_self")
                    }
                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }else if(type=='仅实名'){
                //已登录
                if(loginUserId){
                    //已实名
                    if(authentication=='0'){
                        if(fromUrl){
                            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                        }
                        else {
                            window.open(rootUrl+path,"_self")
                        }
                    }
                    //未实名
                    else {
                        window.open(rootUrl+'/Authentication',"_self")
                    }

                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }
        },
        checkAndHandleAuthentication(){
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          if(!loginUserId){
            this.jumpWithPermission('仅登录','/Login','/rskit/')
          }
          else if(authentication!='0'){
            this.jumpWithPermission('仅实名','/Authentication','/rskit/')
          }
          return true;
        },
        clearKeyword(){
            this.keyword = ''
        },
        customRequest(options) {
            const { file, onProgress, onSuccess, onError } = options;
            this.searchFile(file, onProgress, onSuccess, onError);
        },
        searchFile(file, onProgress, onSuccess, onError) {
            if (["kml", "kmz", "zip"].includes(file.name.slice(-3))) {
                let data = new FormData();
                data.append('file', file);
                this.axios({
                    method: 'post',
                    timeout: 60000,
                    url: '/koa_back/makeGeoValid',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    data: data
                }).then((res) => {
                    if (res.data.erro) {
                        if (onError) {
                            onError(new Error(res.data.erro));
                        }
                        this.fileList = this.fileList.filter(item => item.uid !== file.uid);
                    } else {
                        let geoJson = JSON.parse(res.data.validjson);

                        if (!["Polygon","MultiPolygon"].includes(geoJson.type)) {
                            this.$message.warning('暂不支持使用点或线矢量，请重新上传！')
                            if (onError) onError(new Error("暂不支持点或线矢量"));
                            this.fileList = this.fileList.filter(item => item.uid !== file.uid);
                            return
                        }
                        if (onSuccess) {
                            onSuccess(res.data, file);
                        }
                        this.$refs.mainmap.needEmit = true

                        bus.$emit('showUploadVector', geoJson)

                        let formdataRegion = new FormData()
                        let regionShp=WKT.convert(geoJson)
                        this.regionShape = regionShp
                        this.regionAreaId = null
                        formdataRegion.append("shape",regionShp)
                        this.axios
                        .post("/map_service_back/vectorLibrary/getRegion", formdataRegion)
                        .then(res => {
                            let result = res.data.data
                            result.sort(function(a,b) {
                                return a.area_level-b.area_level
                            })
                            this.countyNameResult=''
                            result.forEach(r => {
                                this.countyNameResult=this.countyNameResult+r.area_name
                            })
                            this.countyNameResult = this.countyNameResult + '（自选区域）'
                            this.customizeName=this.countyNameResult
                        })

                        // let wkt=WKT.convert(geoJson)
                        // let formdata = new FormData()
                        // formdata.append('wkt',wkt)
                        // this.axios.post('/map_service_back/program/getArea', formdata).then((res) => {
                        //     if (res.data.code==200) {
                        //         this.countyAreaResult = res.data.area
                        //     }
                        // })

                        let formdata = new FormData()
                        let geom=JSON.stringify(geoJson)
                        formdata.append("geom",geom)
                        this.axios
                        .post("/map_service_back/program/geomAreaHandle", formdata, {
                            headers: {
                            Authorization: "Bearer " + this.getKey(),
                            },
                        }).then(res => {
                            // debugger
                            if(res.data.message=='当前矢量中要素数量超过10个，暂不能用于创建项目')
                                this.$message.warning('当前矢量中要素数量超过10个，暂不能用于购买区域')
                            // else
                            //     this.$refs.mainmap.makeBufferRegion(res)
                            this.countyAreaResult = this.normalizeCountyArea(res.data.data)
                        }).catch(error => {
                            this.$message.error('矢量解析失败')
                        })


                    }
                }).catch((error) => {
                    if (onError) {
                        onError(error);
                    }
                    this.fileList = this.fileList.filter(item => item.uid !== file.uid);
                });
            } else {
                if (onError) {
                    onError(new Error("不支持的文件类型"));
                }
                this.fileList = this.fileList.filter(item => item.uid !== file.uid);
            }
        },
        // 监听上传变化事件
        handleChangeFile(info) {
            let fileList = [...info.fileList];
            // 限制只能有一个文件（自动覆盖之前的文件）
            if (fileList.length > 1) {
                fileList = fileList.slice(-1); // 只保留最后一个文件
            }
            // 如果文件状态是 removed（已删除），清空列表
            if (info.file.status === 'removed') {
                fileList = [];
            }
            this.fileList = fileList;
        },
        isValidCoordinateString(str) {
            // 1. 检查字符串是否为空
            if (!str || typeof str !== 'string') return false;

            // 2. 按逗号分割成坐标数组
            const coordinatePairs = str.split(',');

            // 3. 检查坐标数量是否至少3个
            if (coordinatePairs.length < 3) return false;

            // 4. 检查每个坐标对和是否有重复
            const seenCoordinates = new Set();
            const coordinateRegex = /^-?\d+(\.\d+)? -?\d+(\.\d+)?$/;

            for (const pair of coordinatePairs) {
                // 4.1 检查格式是否符合"经度 纬度"
                if (!coordinateRegex.test(pair.trim())) {
                return false;
                }

                // 4.2 检查坐标值是否有效
                const [lng, lat] = pair.trim().split(' ').map(Number);
                if (isNaN(lng) || isNaN(lat)) return false;
                if (lng < -180 || lng > 180 || lat < -90 || lat > 90) return false;

                // 4.3 检查是否有重复坐标
                const coordKey = `${lng},${lat}`;
                if (seenCoordinates.has(coordKey)) {
                return false;
                }
                seenCoordinates.add(coordKey);
            }

            return true;
        },
        searchCoord() {
            this.centerLonTrans=false
            this.centerLatTrans=false
            this.minLonTrans=false
            this.minLatTrans=false
            this.maxLonTrans=false
            this.maxLatTrans=false

            if(this.coordTab==1){
                if(this.centerLon==''||this.centerLat==''){
                    // this.$parent.showError('提示：请输入经纬度！')
                    return
                }
                if(this.centerLon<-180||this.centerLon>180||this.centerLat<-90||this.centerLat>90){
                    // this.$parent.showError('提示：请输入正确的经纬度！')
                    return
                }
                if(this.lengthKM=='') this.lengthKM = 2.5
                if(this.widthKM=='') this.widthKM = 2.5
                let center = [this.centerLon,this.centerLat]
                this.showCenterCoord(center,this.lengthKM,this.widthKM)
            }
            else if(this.coordTab==2){
                if(this.minLon==''||this.minLat==''||this.maxLon==''||this.maxLat==''){
                    // this.$parent.showError('提示：请输入经纬度！')
                    return
                }
                if(this.minLon<-180||this.minLon>180||this.minLat<-90||this.minLat>90||this.maxLon<-180||this.maxLon>180||this.maxLat<-90||this.maxLat>90){
                    // this.$parent.showError('提示：请输入正确的经纬度！')
                    return
                }
                // if(this.minLon>this.maxLon||this.minLat>this.maxLat||this.minLon==this.maxLon||this.minLat==this.maxLat){
                //     this.$parent.showError('提示：请输入正确的经纬度！')
                //     return
                // }
                let bound = [this.minLon,this.minLat,this.maxLon,this.maxLat]
                this.showBoundCoords(bound)
            }
            else if(this.coordTab==3){
                let ifValid = this.isValidCoordinateString(this.coordString)
                if(!ifValid){
                    // this.$parent.showError('提示：节点坐标的经纬度不合规，请重新输入！')
                    return
                }
                else this.showFreeCoords(this.coordString)
            }
            this.regionPainted = true
        },
        cleardrawCoords(){
            this.centerLon='',
            this.centerLat='',
            this.centerLons=['','',''],
            this.centerLats=['','',''],
            this.centerLonTrans=false,
            this.centerLatTrans=false,
            this.lengthKM='',
            this.widthKM='',
            this.minLon='',
            this.minLat='',
            this.maxLon='',
            this.maxLat='',
            this.minLons=['','',''],
            this.minLats=['','',''],
            this.maxLons=['','',''],
            this.maxLats=['','',''],
            this.minLonTrans=false,
            this.minLatTrans=false,
            this.maxLonTrans=false,
            this.maxLatTrans=false,
            this.coordString=''
            this.cancelArea()
        },
        customizeNameAdd(){
            if(this.customizeName.length>0){
                if(this.customizeName.slice(-6)!='（自选区域）'){
                this.customizeName=this.customizeName+'（自选区域）'
                }
            }
        },
        /** 从路由 query 预选「基础/高级图源」（第二步 picSel），与 switchPicSel(2) 对应高级图源列表 */
        applyPicSelFromRoute() {
            const q = this.$route.query;
            const ps = q.picSel != null ? String(q.picSel) : '';
            if (ps === '2' || q.sourceTab === '2' || q.tier === 'premium' || q.sourceTier === 'premium') {
                this.picSel = 2;
                return;
            }
            if (ps === '1' || q.sourceTab === '1' || q.tier === 'basic' || q.sourceTier === 'basic') {
                this.picSel = 1;
            }
        },
        //清空所有，恢复默认
        clearStep2(){
            this.page=1
            this.tab2Sel=1
            this.countyNameResult=''
            this.customizeName=''
            this.countyAreaResult=-1
        },
        //初始化列表
        initDataList() {
            this.dataList = this.dataList.map((series) => {
                return {
                    ...series,
                    isExpanded: true,
                    list: series.list.map(item => ({
                        ...item,
                        selected: false
                    }))
                };
            });
        },
        formatApiList(list, typeName) {
            if (!Array.isArray(list)) return [];
            return list.map(series => ({
                name: folderMapping[series.series] || series.name || '',
                list: (series.value || []).map(item => ({
                    id: item.id,
                    mkId: item.id,
                    mkIv: item.iv,
                    name: item.name || '',
                    imageGsd: `${item.resolution || ''}m分辨率`,
                    type: typeName,
                    mkType: Number(item.type) || 0,
                    price: Number(item.price) || 0,
                }))
            }));
        },
        switchPicSel(type) {
            this.picSel = type;
            this.dataList = type === 1
                ? JSON.parse(JSON.stringify(this.basicDataList))
                : JSON.parse(JSON.stringify(this.premiumDataList));
            this.initDataList();
        },
        goStep2() {
            if (!(this.customizeName.length > 0 && this.countyNameResult != '' && this.countyAreaResult >= 25)) {
                return;
            }
            this.requestUserCenterBeforeAnnualStep2();
        },
        async requestUserCenterBeforeAnnualStep2() {
            try {
                const res = await this.axios.get("/loginapi/getUserForUserCenter", {
                    headers: {
                        Authorization: "Bearer " + this.getKey(),
                    },
                });
                if (res.status != 200) {
                    alert("系统错误");
                    return;
                }
                await checkUserCert({
                    axios: this.axios,
                    token: this.getKey(),
                    outerRes: res,
                    onStatus: (code) => { this.userIdentityReviewStatus = code; },
                    onProceed: () => this.proceedGoStep2MkList(),
                    onShowIdentityPicker: () => { this.shadowTip = true; },
                    onNavigate: (path) => this.jumpWithPermission("仅实名", path, "/rskit" + this.$route.fullPath),
                    onOpenAuthLetterDialog: (mode, rejectReason) => {
                        this.authLetterModalMode = mode;
                        this.authorizationLetterRejectReason = rejectReason || '';
                        this.authLetterModalVisible = true;
                    },
                });
            } catch (e) {
                alert("系统错误");
            }
        },
        onAuthLetterSuccess() {
            // 委托书需 1-3 个工作日审核。审核通过前不可进入第 2 步选图源。
            // 用户后续重新点击"下一步"再次触发 cert check，
            // 若 letter status 已是 proceed（新 API statusCode 6/12），
            // 才进入 proceedGoStep2MkList。这里不做任何操作，component 内部已 topTip 提示。
        },
        onAuthLetterFail() {
            // component 内部已 topTip 提示上传失败，这里无需额外动作
        },
        proceedGoStep2MkList() {
            const area = Number(this.countyAreaResult);
            this.axios.get(`/tileflowapi/flow/package/getMkList?area=${area}`, {
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                },
            }).then((res) => {
                if (res.data && res.data.code === 200 && res.data.data) {
                    const result = res.data.data;
                    this.basicPrice = Number(result.basicPrice) || 0;
                    this.premiumPrice = Number(result.premiumPrice) || 0;
                    this.basicDataList = this.formatApiList(result.basic, '基础图源');
                    this.premiumDataList = this.formatApiList(result.premium, '高级图源');
                    this.selectedBasicItems = [];
                    this.selectedPremiumItems = [];
                    this.switchPicSel(this.picSel);
                    this.page = 2;
                    return;
                }
                this.$message.error((res.data && res.data.msg) || '获取图源列表失败');
            }).catch((err) => {
                const msg = (err.response && err.response.data && err.response.data.msg) || err.message || '获取图源列表失败';
                this.$message.error(msg);
            });
        },
        saveAnnualPurchaseState() {
            const state = {
                page: this.page,
                picSel: this.picSel,
                curPlaceTab: this.curPlaceTab,
                tab2Sel: this.tab2Sel,
                countyNameResult: this.countyNameResult,
                customizeName: this.customizeName,
                countyAreaResult: this.countyAreaResult,
                regionAreaId: this.regionAreaId,
                regionShape: this.regionShape,
                basicPrice: this.basicPrice,
                premiumPrice: this.premiumPrice,
                basicDataList: this.basicDataList,
                premiumDataList: this.premiumDataList,
                selectedBasicItems: this.selectedBasicItems,
                selectedPremiumItems: this.selectedPremiumItems,
            };
            localStorage.setItem('annualPurchasePurchaseState', JSON.stringify(state));
        },
        restoreAnnualPurchaseState() {
            if (!this.$route.query.backStep) {
                return;
            }
            const cache = localStorage.getItem('annualPurchasePurchaseState');
            if (!cache) {
                return;
            }
            try {
                const state = JSON.parse(cache);
                this.picSel = state.picSel || 1;
                this.curPlaceTab = state.curPlaceTab || 1;
                this.tab2Sel = state.tab2Sel || 1;
                this.countyNameResult = state.countyNameResult || '';
                this.customizeName = state.customizeName || '';
                this.countyAreaResult = this.normalizeCountyArea(state.countyAreaResult);
                this.regionAreaId = state.regionAreaId || null;
                this.regionShape = state.regionShape || '';
                this.basicPrice = Number(state.basicPrice) || 0;
                this.premiumPrice = Number(state.premiumPrice) || 0;
                this.basicDataList = state.basicDataList || [];
                this.premiumDataList = state.premiumDataList || [];
                this.selectedBasicItems = state.selectedBasicItems || [];
                this.selectedPremiumItems = state.selectedPremiumItems || [];
                if (this.$route.query.backStep === '1') {
                    this.page = 1;
                    return;
                }
                this.page = 2;
                this.dataList = this.picSel === 1
                    ? JSON.parse(JSON.stringify(this.basicDataList))
                    : JSON.parse(JSON.stringify(this.premiumDataList));
                this.initDataList();

                bus.$off('loadGisMapRunOver')
                bus.$on('loadGisMapRunOver', () => {
                    this.loadPurchaseState()
                })
            } catch (e) {
                // ignore invalid cache
            }
        },
        // 切换系列的展开/折叠状态
        toggleSeries(index) {
            this.dataList[index].isExpanded = !this.dataList[index].isExpanded;
        },
        // 检查某个项目是否被选中
        isSelected(seriesIndex, itemIndex) {
            const item = this.dataList[seriesIndex].list[itemIndex];
            const selectedList = this.picSel === 1 ? this.selectedBasicItems : this.selectedPremiumItems;
            return selectedList.some(selected => selected.item.mkId === item.mkId);
        },
        // 获取系列中已选择的数量
        getSeriesSelectedCount(seriesIndex) {
            const seriesName = this.dataList[seriesIndex].name;
            const selectedList = this.picSel === 1 ? this.selectedBasicItems : this.selectedPremiumItems;
            return selectedList.filter(item => item.seriesName === seriesName).length;
        },
        // 切换选择状态
        toggleSelect(seriesIndex, itemIndex) {
            const item = this.dataList[seriesIndex].list[itemIndex];
            const seriesName = this.dataList[seriesIndex].name;
            const selectedList = this.picSel === 1 ? this.selectedBasicItems : this.selectedPremiumItems;
            // 查找是否已经选中
            const existingIndex = selectedList.findIndex(selected => selected.item.mkId === item.mkId);
            if (existingIndex > -1) {
                // 如果已经选中，则取消选择
                selectedList.splice(existingIndex, 1);

                if (selectedList.length>0) {
                    let cur=selectedList[selectedList.length-1]

                    // 地图显示该期图，并切换镶嵌线图层
                    let curlayer
                    let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
                    allLayers.forEach(layer => {
                        if (layer instanceof Tile && layer.getVisible() && layer.values_.title!='天地图注记') {
                            layer.setVisible(false)
                        }
                        if (layer.values_.title==cur.item.name) {
                            curlayer=layer
                        }
                    })
                    if (curlayer) {
                        curlayer.setVisible(true)
                        this.curLayerName = curlayer.values_.title

                        for (let i = 0; i < this.mkList.length; i++) {
                            const m = this.mkList[i];
                            if (m.name==this.curLayerName) {
                                this.curMk=m.mkIV
                                break
                            }
                        }
                    }

                    this.showVectorTileLayer = true
                    this.vectorTileLayer.getSource().setUrl(`${this.tileBaseUrl}/getTileMVT/{z}/{x}/{-y}?mk=${this.curMk}&tk=${this.tk}&free_sensitive=${this.free_sensitive}`)
                    this.showImageTime='隐藏拍摄时间'
                    this.vectorTileLayer.setVisible(true)


                }else{
                    // 关闭镶嵌线图层
                    this.showVectorTileLayer = false
                    this.showImageTime='显示拍摄时间'
                    this.vectorTileLayer.setVisible(false)
                }
            } else {
                // 如果未选中，则添加到选择列表
                selectedList.push({
                    seriesIndex,
                    itemIndex,
                    seriesName,
                    item: { ...item }
                });

                // 地图显示该期图，并切换镶嵌线图层
                let curlayer
                let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
                allLayers.forEach(layer => {
                    if (layer instanceof Tile && layer.getVisible() && layer.values_.title!='天地图注记') {
                        layer.setVisible(false)
                    }
                    if (layer.values_.title==item.name) {
                        curlayer=layer
                    }
                })
                if (curlayer) {
                    curlayer.setVisible(true)
                    this.curLayerName = curlayer.values_.title

                    for (let i = 0; i < this.mkList.length; i++) {
                        const m = this.mkList[i];
                        if (m.name==this.curLayerName) {
                            this.curMk=m.mkIV
                            break
                        }
                    }
                }

                this.showVectorTileLayer = true
                this.vectorTileLayer.getSource().setUrl(`${this.tileBaseUrl}/getTileMVT/{z}/{x}/{-y}?mk=${this.curMk}&tk=${this.tk}&free_sensitive=${this.free_sensitive}`)
                this.showImageTime='隐藏拍摄时间'
                this.vectorTileLayer.setVisible(true)
            }
        },
        submitAnnualOrder() {
            if (this.selectedCount < 1) {
                this.$message.warning('请选择图源');
                return;
            }
            if (!this.regionAreaId && !this.regionShape) {
                this.$message.warning('请先完成区域选择');
                return;
            }
            const allSelected = [...this.selectedBasicItems, ...this.selectedPremiumItems];
            const mkName = allSelected.map(item => item.item.name).join('、');
            const mkList = allSelected.map(item => ({
                mkId: item.item.mkId,
                mkType: item.item.mkType,
                unitPrice: (item.item.mkType === 1 || item.item.mkType === 4) ? this.basicPrice : this.premiumPrice,
            }));
            const orderJson = {
                areaId: this.regionAreaId || null,
                shape: this.regionShape || null,
                regionName: this.countyNameResult,
                regionArea: Number(this.countyAreaResult),
                curPlaceTab: this.curPlaceTab,
                mkName,
                basicPrice: Number(this.basicTotalPrice.toFixed(3)),
                premiumPrice: Number(this.premiumTotalPrice.toFixed(3)),
                payFinal: Number(this.totalPrice.toFixed(3)),
                mkList,
            };
            this.saveAnnualPurchaseState();
            localStorage.setItem('annualPurchaseOrderDraft', JSON.stringify(orderJson));
            this.$router.push('/AnnualPurchase/annualSubmitOrder');
        },

        cancelArea(){
            this.chinaProvinceNow=undefined
            this.chinaCityNow=undefined
            this.chinaCountyNow=undefined
            this.countyNameResult = ''
            this.customizeName=''
            this.countyAreaResult=-1
            this.regionAreaId=null
            this.regionShape=''
            this.fileList = []
            this.shapeSel = 0
            //把你的绘制区域的内容清空
            bus.$emit('clean')
        },

        // 输入区域坐标：中心点
        showCenterCoord(point,length,width){
            // this.clearAll()
            bus.$emit('clean')
            // this.targetType = 'draw'

            let lon = Number(point[0])
            let lat = Number(point[1])
            let meters_per_lat = 2 * Math.PI * 6378137 / 360    //计算纬度单位度数的实际距离，单位米
            let meters_per_lon = meters_per_lat * Math.cos(lat * Math.PI / 180) //计算经度单位度数的实际距离，单位米
            let lon_length = length * 1000 / meters_per_lon
            let lat_length = width * 1000 / meters_per_lat
            let rec = []
            rec.push([lon - lon_length, lat - lat_length])
            rec.push([lon - lon_length, lat + lat_length])
            rec.push([lon + lon_length, lat + lat_length])
            rec.push([lon + lon_length, lat - lat_length])
            rec.push([lon - lon_length, lat - lat_length])

            let geometry={
            "type": "Polygon",
            "coordinates": [rec]
            }
            bus.$emit('showUploadVector', geometry)
            bus.$emit('buyDrawFinish')

            // this.selectedRangeStore['draw']  = geometry
            // let bounds = [[lat - lat_length,lon - lon_length],[lat + lat_length,lon + lon_length]]
            // this.tmp = L.rectangle(bounds)
            // this.$refs.map.mapObject.addLayer(this.tmp.setStyle(this.targetGeojsonStyle))
            // this.addTooltip(1)
            // this.tmp.editing.enable();
            // this.tmp.on('edit', () => this.updateEdit(1));
            // this.showDraw()
        },
        // 输入区域坐标：角点坐标
        showBoundCoords(bound){
            // this.clearAll()
            bus.$emit('clean')
            // this.targetType = 'draw'

            let rec = []
            rec.push([bound[0], bound[1]])
            rec.push([bound[0], bound[3]])
            rec.push([bound[2], bound[3]])
            rec.push([bound[2], bound[1]])
            rec.push([bound[0], bound[1]])

            let geometry={
            "type": "Polygon",
            "coordinates": [rec]
            }
            bus.$emit('showUploadVector', geometry)
            bus.$emit('buyDrawFinish')

            // this.selectedRangeStore['draw']  = geometry
            // let bounds = [[bound[1],bound[0]],[bound[3],bound[2]]]
            // this.tmp = L.rectangle(bounds)
            // this.$refs.map.mapObject.addLayer(this.tmp.setStyle(this.targetGeojsonStyle))
            // this.addTooltip(1)
            // this.tmp.editing.enable();
            // this.tmp.on('edit', () => this.updateEdit(1));
            // this.showDraw()
        },
        // 输入区域坐标：节点坐标
        showFreeCoords(coordString){
            // this.clearAll()
            bus.$emit('clean')
            // this.targetType = 'draw'

            // 提取字符串坐标序列
            let latlngs = coordString.split(',').map(pair => {
            const [lng, lat] = pair.trim().split(' ').map(Number);
            return [lng, lat];
            });
            latlngs.push(latlngs[0]);
            let geometry={
            "type": "Polygon",
            "coordinates": [latlngs]
            }
            bus.$emit('showUploadVector', geometry)
            bus.$emit('buyDrawFinish')

            // this.selectedRangeStore['draw']  = geometry
            // this.tmp = L.GeoJSON.geometryToLayer(geometry)
            // this.$refs.map.mapObject.addLayer(this.tmp.setStyle(this.targetGeojsonStyle))
            // this.addTooltip(0)
            // this.tmp.editing.enable();
            // this.tmp.on('edit', () => this.updateEdit(0));
            // this.showDraw()
        },

        loadPurchaseState() {
            const purchaseState = localStorage.getItem('annualPurchasePurchaseState');
            if (!purchaseState) {
                return;
            }
            try {
                let purchaseStateObj = JSON.parse(purchaseState);
                this.countyNameResult=purchaseStateObj.countyNameResult
                this.customizeName=purchaseStateObj.customizeName
                this.countyAreaResult=purchaseStateObj.countyAreaResult
                let geojson=JSON.parse(purchaseState).regionShape
                geojson = WKT.parse(geojson)
                bus.$emit('showUploadVector', geojson)
            } catch (e) {
                console.log('e',e)
            }
        },

        getTk() {
            this.axios.get("/tileflowapi/imagery/getUserTk", {
                params: { callScenario: "jl1" },
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                },
            }).then(res => {
                if (res.data.code==200) {
                    this.tk = res.data.data.tk
                    this.sk = res.data.data.sk
                    this.loadMkList();
                }
            });
        },
        async loadMkList() {
            let axiosArr = []
            axiosArr.push(this.axios.get("/tileflowapi/imagery/mk/series", {params: { type:"basic", callScenario: "jl1" },headers: {Authorization: "Bearer " + this.getKey()}}))
            axiosArr.push(this.axios.get("/tileflowapi/imagery/mk/series", {params: { type:"premium", callScenario: "jl1" },headers: {Authorization: "Bearer " + this.getKey()}}))

            let res = await Promise.all(axiosArr)
            let dataList=[]
            for (let index = 0; index < res.length; index++) {
                const r = res[index];
                let data = r.data.data || [];
                data.forEach(d => {
                    d.name=folderMapping[d.series]
                })

                if (index==0) {
                    dataList = data
                } else {
                    dataList = [...dataList, ...data]
                }
            }

            this.mkList = []
            for (let i = 0; i < dataList.length; i++) {
                const f = dataList[i];
                for (let j = 0; j < f.value.length; j++) {
                    let d=f.value[j]
                    this.mkList.push({mkIV:d.iv,name:d.name,tkIV:this.tk,sk:this.sk,type:d.type,pro:d.pro})
                }
            }

            this.lyrdata = []
            this.mkList.forEach(v => {
                let temp = {
                    lyrType: "Tile",
                    srcType: "XYZ",
                    mUrl: `${this.tileBaseUrl}/getTile/{z}/{x}/{-y}?mk=${v.mkIV}&tk=${v.tkIV}&vf=0${v.pro?'&pro='+v.pro:''}`,
                    mTitle: v.name,
                    mName: v.name,
                    sk: v.sk,
                    type: v.type,
                    mExtent: [73.5013,3.4065,135.0961,53.5632],
                    mVisible: false
                }
                this.lyrdata.push(temp)
            })
            // this.lyrdata.push({
            //     lyrType: "lVector",
            //     srcType: "Vector",
            //     mUrl: '',
            //     mTitle: "边框",
            //     mName: "边框",
            //     mVisible: true
            // })
            // this.lyrdata.push({
            //     lyrType: "VectorTile",
            //     srcType: "VectorTile",
            //     mUrl: '',
            //     mTitle: "矢量切片图层",
            //     mName: "矢量切片图层",
            //     mVisible: true
            // })
            this.lyrdata[0].mVisible = true
            this.curLayerName = this.lyrdata[0].mName
            this.mapShow=true
        },

        showVectorLayer(){
            if(this.vectorTileLayer){
                if(this.showImageTime=='显示拍摄时间'){
                    this.showImageTime='隐藏拍摄时间'
                    this.vectorTileLayer.setVisible(true)
                }
                else{
                    this.showImageTime='显示拍摄时间'
                    this.vectorTileLayer.setVisible(false)
                }
            }
        },
        loadVectorTile(){
            this.$refs.mainmap.map.removeLayer(this.vectorTileLayer)
            this.vectorTileLayer=new VectorTileLayer({
                source: new VectorTile({
                format: new MVT(),
                    url: `${this.tileBaseUrl}/getTileMVT/{z}/{x}/{-y}?mk=${this.curMk}&tk=${this.tk}&free_sensitive=${this.free_sensitive}`
                    // url: `https://api.jl1mall.com/getTileMVT/{z}/{x}/{-y}?mk=${this.curmk}`
                }),
                style: this.customStyleFunction,
                minZoom:10,
                maxZoom:15,
                visible:false,
                zIndex: 1
            })
            this.$refs.mainmap.map.addLayer(this.vectorTileLayer)
        },
        customStyleFunction(feature, resolution) {
            const defaultStyle = new Style({
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.01)'
                }),
                stroke: new Stroke({
                    color: '#319FD3',
                    width: 1
                })
            });
            const selectStyle = new Style({
                fill: new Fill({
                    color: 'rgba(255, 255, 255, 0.01)'
                }),
                stroke: new Stroke({
                    color: '#319FD3',
                    width: 1
                }),
                text: new Text({
                    font: '12px Tensentype-ZhiHeiJ-W2',
                    stroke: new Stroke({
                        color: '#3D99C1',
                        width: 1,
                    }),
                    fill: new Fill({
                        color: 'rgba(255, 255, 255, 1)',
                    }),
                    backgroundFill: new Fill({
                        color: 'rgba(0,0,0,0.34)',
                    }),
                    padding: [2, 5, 2, 5],
                    text: feature.properties_.imagingTime,
                    overflow: true
                })
            });
            const redStyle = new Style({
                fill: new Fill({
                    color: 'rgba(224,32,32,0.1)'
                }),
                stroke: new Stroke({
                    color: '#E02020',
                    width: 2
                }),
                text: new Text({
                    font: '12px Tensentype-ZhiHeiJ-W2',
                    stroke: new Stroke({
                        color: '#E02020',
                        width: 1,
                    }),
                    fill: new Fill({
                        color: 'rgba(255, 255, 255, 1)',
                    }),
                    backgroundFill: new Fill({
                        color: 'rgba(0,0,0,0.34)',
                    }),
                    padding: [2, 5, 2, 5],
                    text: feature.properties_.imagingTime
                }),
                zIndex: 1
            });

            try {
                // let coordinates = Array.from(feature.flatCoordinates_)
                // let coorArr = []
                // for (let i = 0; i < coordinates.length; i=i+2) {
                //   coorArr.push([coordinates[i],coordinates[i+1]])
                // }
                // let geom = new Feature({
                //   geometry: new Polygon([coorArr])
                // })
                // geom.getGeometry().transform('EPSG:3857', 'EPSG:4326')
                // let geoJSONGeometry = JSON.parse(new GeoJSON().writeFeature(geom));//转为geojson

                // let isinsect = turf.intersect(geoJSONGeometry,JSON.parse(this.areaGeo))

                let ymd = feature.properties_.imagingTime
                if (ymd) {
                    ymd = ymd.split(' ')[0].split('-')
                    if (ymd[0] != this.curyear) return redStyle
                    else if (this.curyear == '2025') {
                        if (ymd[1] < this.cursort * 2 - 1) return redStyle
                        else return selectStyle
                    }
                    else if (this.curyear == '2023' || this.curyear == '2024') {
                        if (ymd[1] < this.cursort * 3 - 2) return redStyle
                        else return selectStyle
                    }
                }
            } catch (error) {
                return
            }
        },
    }
}
</script>
<style scoped>
.step1Head{
    position: absolute;
    left: 0;
    top: 0;
    width: 100px;
    height: 24px;
    cursor: pointer;
    z-index: 1;
}
.step2Icon{
    position: absolute;
    width: 24px;
    top: 0;
    left: 0;
}
.step2ScrollCtn{
    position: relative;
    margin-top: 23px;
    width: 100%;
    height: calc(100% - 379px);
    overflow-x: hidden;
    overflow-y: auto;
}
.step2Area{
    position: relative;
    margin-top: 0px;
    margin-left: 40px;
    width: 520px;
    height: 60px;
}
.step2AreaText1{
    position: absolute;
    top: 0;
    left: 0;
    width:auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
.step2AreaText2{
    position: absolute;
    top: 40px;
    right: 0;
    width: auto;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #1677FF;
    line-height: 20px;
    cursor: pointer;
}
.step2Text1{
    position: relative;
    margin-top: 24px;
    margin-left: 40px;
    width: auto;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 20px;
}
.step2Ctn{
    position: relative;
    margin-top: 16px;
    margin-left: 24px;
    width: 552px;
    height: 30px;
    cursor: pointer;
    border-bottom: 1px solid #F0F0F0;
}
.stepCtnBtn1{
    position: absolute;
    width: 276px;
    height: 30px;
    background: #F5F5F5;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    line-height: 30px;
    text-align: center;
}
.stepCtnBtn1-s{
    position: absolute;
    width: 276px;
    height: 30px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    line-height: 30px;
    text-align: center;
}
.stepCtnBtn1Line{
    position: absolute;
    bottom: 0;
    left: 69px;
    width: 138px;
    height: 2px;
    background: #000000;
}
.step2ListCtn{
    position: relative;
    margin-top: 17px;
    margin-left: 24px;
    width: 600px;
}
.step2ListHead{
    position: relative;
    width: 552px;
    height: 38px;
    background: #FAFAFA;
    margin-bottom: 6px;
}
.step2LixtText1{
   float: left;
   margin-top: 8px;
   margin-left: 24px;
   width:auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
.step2ListIcon1{
    position: absolute;
    width: 14px;
    top: 15px;
    right: 21px;
    cursor: pointer;
}
.step2ListIcon2{
    position: absolute;
    width: 9px;
    top: 11px;
    right: 23px;
    cursor: pointer;
}
.step2ListTable{
    position: relative;
    margin-bottom: 12px;
    width: 552px;
    height: 46px;
    border-radius: 4px;
    border: 1px solid #D9D9D9;
}
.step2ListTable-s{
    position: relative;
    margin-bottom: 12px;
    width: 552px;
    height: 46px;
    border-radius: 4px;
    border: 1px solid #1890FF;
}
.step2LixtText2{
    float: left;
    margin-top: 12px;
    margin-left: 24px;
    width: auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
.step2LixtText3{
    float: left;
    margin-top: 12px;
    margin-left: 16px;
    padding-left: 8px;
    padding-right: 8px;
    width:auto;
    height: 22px;
    background: #F5F5F5;
    border-radius: 4px;
    border: 1px solid #D9D9D9;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
    text-align: center;
}
.step2LixtText4{
    position: absolute;
    top: 13px;
    left: 420px;
    width:auto;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #FF0000;
    line-height: 20px;
    text-align: left;
}
.step2ListIcon3{
    position: absolute;
    width: 16px;
    top: 15px;
    right: 10px;
    cursor: pointer;
}
.step2Text2{
  position: absolute;
  left: 48px;
  bottom:104px;
  width: auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
.step2Text3{
    position: absolute;
    left: 453px;
    bottom: 104px;
    width: auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
</style>
<style scoped>
.background{
    position: relative;
    margin-top: 76px;
    margin-left: 0;
    width: 100vw;
    height: calc(100vh - 76px);
    overflow: hidden;
}
.left{
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: calc(100% - 600px);
    /* background-image: url(../../../assets/dataPack/AnnualPurchase/背景.png);
    background-size: cover; */
}
.right{
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 600px;
    overflow-y: auto;
    overflow-x: hidden;
}
.rightText1{
    position: relative;
    margin-top: 40px;
    width: 600px;
    height: 38px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 30px;
    color: rgba(0,0,0,0.85);
    line-height: 38px;
    text-align: center;
}
.step{
    position: relative;
    width: 490px;
    height: 24px;
    margin-top: 24px;
    margin-left: 64px;
}
.circle1{
    position: absolute;
    width: 24px;
    height: 24px;
    border-radius:50% ;
    background: #1890FF;
}
.rightText2{
    position: absolute;
    width: 24px;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 24px;
    text-align: center;
}
.rightText3{
    position: absolute;
    left: 32px;
    width: 56px;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    line-height: 24px;
}
.rightLine1{
    position: absolute;
    top: 12px;
    left: 100px;
    width: 80px;
    height: 1px;
    background: #108EE9;
}
.circle2{
    position: absolute;
    top: 0;
    left: 192px;
    width: 24px;
    height: 24px;
    border: 1px solid rgba(0,0,0,0.15);
    border-radius: 50%;
}
.rightText4{
    position: absolute;
    width: 24px;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.25);
    line-height: 24px;
    text-align: center;
}
.rightText5{
    position: absolute;
    left: 224px;
    width: 56px;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.45);
    line-height: 24px;
    cursor: pointer;
}
.rightLine2{
    position: relative;
    margin-top: 16px;
    margin-left: 24px;
    width: 552px;
    height: 1px;
    border: 1px dashed #D9D9D9;
}
.searchInput{
    position: relative;
    margin-top: 15px;
    margin-left: 40px;
    width: 456px;
    height: 46px;
    background: #FAFAFA;
    border-radius: 5px;
    border: 1px solid #D9D9D9;
}
.searchInputText{
    position: absolute;
    top: 12px;
    left: 48px;
    width: 400px;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 14px;
    color: #000;
    line-height: 22px;
    border: none;
    outline: none;
}
.clearBtn{
    position: absolute;
    width: 15px;
    height: 15px;
    top: 14px;
    right: 10px;
    background: url("../../../assets/dataPack/AnnualPurchase/关闭.png");
    background-size: cover;
    cursor: pointer;
}
.searchInputIcon1{
    position: absolute;
    top: 165px;
    right: 40px;
    width: 32px;
    height: 32px;
    cursor: pointer;
}
.searchCtn{
    position: relative;
    margin-top: 15px;
    margin-left: 40px;
    width: 475px;
    height: 46px;
}
.selTab{
    position: relative;
    margin-top: 16px;
    margin-left: 40px;
    width: 520px;
    height: 32px;
    border-bottom: 1px solid #D9D9D9;
}
.selTabCtn1Sel{
    position: relative;
    float: left;
    width: 88px;
    height: 32px;
    border-bottom: 2px solid #0066CC;
    cursor: pointer;
}
.selTabCtn1{
    position: relative;
    float: left;
    width: 88px;
    height: 32px;
    cursor: pointer;
}
.selTabCtn1Img{
    position: absolute;
    top: 4px;
    left:0px;
    width: 16px;
}
.selTabCtn1TextSel{
    position: absolute;
    right: 0;
    width: auto;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #1890FF;
    line-height: 24px;
}
.selTabCtn1Text{
    position: absolute;
    right: 0;
    width: auto;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    line-height: 24px;
}
.tab1{
    position: relative;
    width: 520px;
    margin-left: 40px;
    height: 265px;
    border-bottom: 1px solid #D9D9D9;
}
.tab1Input{
    position: relative;
    float: left;
    margin-top: 24px;
    width: 384px!important;
    height: 170px!important;
    background: rgba(0,0,0,0.02);
    border-radius: 4px;
    border: 1px solid rgba(0,0,0,0.15);
}
.tab1Btn{
    position: relative;
    float: left;
    margin-top: 24px;
    margin-left:38px;
    width: 82px;
    height: 32px;
    border-radius: 6px;
    border: 1px solid #D9D9D9;
    cursor: pointer;
}
.tab1BtnIcon{
    position: absolute;
    top: 10px;
    left: 16px;
}
.tab1BtnText{
    position: absolute;
    top: 5px;
    left: 38px;
    width: 28px;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
.tab1Tip{
    position: relative;
    margin-top: 45px;
    float: left;
    width:auto;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.45);
    line-height: 20px;
}
.tab2Radio{
    position: relative;
    width: 450px;
    margin-top: 24px;
    margin-left: 24px;
}
.tab2Select{
    position: relative;
    width: 112px;
    margin-top: 24px;
}
.tab2Text1{
    position: relative;
    margin-top: 24px;
    margin-left: 24px;
    width:auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
.selCoordTab{
    position: relative;
    margin-top: 16px;
    margin-left: 0px;
    width: 520px;
    height: 22px;
}
.selCoordCtn1{
    position: relative;
    float: left;
    width: 166px;
    height: 22px;
    cursor: pointer;
}
.selCoordText{
    position: absolute;
    left: 0px;
    width: 100%;
    height: 22px;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #3A3A3A;
    line-height: 22px;
}
.selCoordTextSel{
    position: absolute;
    left: 0px;
    width: 100%;
    height: 22px;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #0066CC;
    line-height: 22px;
}
.selCoordDivider{
    position: absolute;
    right: 0px;
    width: 1px;
    height: 10px;
    top: 7px;
    background-color: rgba(0, 0, 0, 0.85);
}
.coordCtn{
    position: relative;
    margin-top: 16px;
    width: 520px;
    height: 100px;
}
.quarterPart{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 438px;
    height: 72px;
}
.inputTitle{
    position: absolute;
    width: auto;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.65);
    line-height: 26px;
    text-align: right;
}
.inputCtn{
    position: absolute;
    left: 92px;
    width: 80px;
    height: 22px;
    background: #FAFAFA;
    border-radius: 5px;
    border: 1px solid #D9D9D9;
}
.searchInput1{
    position: absolute;
    left: 8px;
    width: 372px;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: #000;
    line-height: 22px;
    text-align: left;
    border: none;
    outline: none;
}
.searchInput1Icon1{
    position: absolute;
    width: 16px;
    top: 3px;
    left: 180px;
    cursor: pointer;
}
.transCtn{
    position: absolute;
    left:61px;
    top: 25px;
    width:142px;
    height:22px;
    background: #F9FAFB;
    border:1px solid #a4a4a4;
    border-radius:5px;
    display:flex;
    font-family: PingFangSC, PingFang SC;
    font-weight: 300;
    font-size: 10px;
    color: #7F7F7F;
}
.inputCtn2{
    position: absolute;
    left: 24px;
    width: 360px;
    height: 76px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid rgba(0,0,0,0.15);
}
.searchInput2{
    position: absolute;
    top: 5px;
    left: 12px;
    width: 336px;
    height: 70px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000;
    line-height: 18px;
    text-align: left;
    border: none;
    outline: none;
    resize: none;
}
.selCtn2SelBtn1Hover{
    position: absolute;
    left: 438px;
    width: 82px;
    height: 32px;
    background: #1890FF;
    border-radius: 6px;
    cursor: pointer;
}
.selCtn2SelBtn1Img{
    position: absolute;
    width: 12px;
    top: 10px;
    left: 16px;
}
.selTabCtn2Btn1Text{
    position: absolute;
    left: 38px;
    width: auto;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 32px;
}
.selTabCtn2Btn1{
    position: absolute;
    top: 40px;
    left: 438px;
    width: 82px;
    height: 32px;
    border-radius: 6px;
    border: 1px solid #D9D9D9;
    cursor: pointer;
}
.selTabCtn2Btn1Img{
    position: absolute;
    width: 12px;
    top: 10px;
    left: 16px;
}
.selTabCtn2Btn1TextHover{
    position: absolute;
    left: 38px;
    width: auto;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 32px;
}
.selTabCtn2Text2{
    position: absolute;
    top: 74px;
    width:auto;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.45);
    line-height: 20px;
    text-align: left;
}
.selCtn2Img{
    position: absolute;
    top: 24px;
    width: 100px;
    height: 64px;
    cursor: pointer;
}
.selCtn2Text1{
    position: absolute;
    top: 96px;
    left: 9px;
    width: 83px;
    height: 24px;
    background: #1890FF;
    border-radius: 4px;
    border: 1px solid #1890FF;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 24px;
    text-align: center;
}
.rightText6{
    position: relative;
    margin-left: 40px;
    margin-top: 24px;
    width: 550px;
    height: 22px;
}
.rightText7{
    position: absolute;
    width:auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 22px;
    text-align: left;
}
.rightText8{
    position: absolute;
    left: 80px;
    width:auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
.areaNameInput{
  position: absolute;
  left: 80px;
  width: 440px;
  height: 22px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
  text-align: left;
  border-bottom: 1px solid #D9D9D9;
  outline: none;
}
.rightIcon1{
   position: absolute;
    bottom: 150px;
    right: 40px;
    cursor: pointer;
}
.rightLine3{
   position: absolute;
   left: 24px;
   bottom: 149px;
    width: 522px;
    height: 1px;
    border-top: 1px dashed #D9D9D9;
}
.rightBtn{
    position: absolute;
   bottom: 24px;
   left: 48px;
    width: 504px;
    height: 56px;
    background: #BFBFBF;
    border-radius: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 56px;
    text-align:center;
    cursor: pointer;
}
.rightBtn-s{
    position: absolute;
   bottom: 24px;
   left: 48px;
    width: 504px;
    height: 56px;
    background: #1890FF;
    border-radius: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 56px;
    text-align:center;
    cursor: pointer;
}
</style>
<style scoped>
/* 移除所有数字输入框的箭头 */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
<style lang="less" scoped>
.mapPanel {
  width: 100%;
  height: 100%;
}
.areaButton1{
  position: absolute;
  top: 0;
  left: 0;
  width: 81px;
  height: 36px;
  background: #6A6A6A;
  border-radius: 6px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
}
.areaButton1-s{
  position: absolute;
  top: 0;
  left: 0;
  width: 81px;
  height: 36px;
  background: #2F66CC;
  border-radius: 6px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
}
.redHint{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 56px;
  background: rgba(0,0,0,0.34);
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #FFFFFF;
  line-height: 56px;
  text-align: left;
  display: flex;
//   padding-left: 40px;
}
.curMk{
    width: 30%;
    height: 62px;
    background: #000000;
    padding-left: 40px;
}
.mkTips{
    padding-left: 40px;
}
</style>
<style scoped>
.shadow{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000001;
    background: rgba(0,0,0,0.4);
}
.shadowWhite{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 776px;
    height: 428px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #979797;
}
.shadowClose{
    position: absolute;
    top: 28px;
    right: 40px;
    width: 20px;
    z-index: 1;
    font-size: 32px;
    color: #000000;
    cursor: pointer;
}
.shadowText1{
    position: absolute;
    top: 32px;
    width: 100%;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
    text-align: center;
}
.shadowText2{
    position: absolute;
    top: 88px;
    left: 64px;
    width: 648px;
    height: 64px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 32px;
}
.shadowSel{
    position: absolute;
    top: 192px;
    left: 100px;
    width: 276px;
    height: 157px;
    cursor: pointer;
    background: rgba(0,0,0,0.4);
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
    overflow: hidden;
}
.shadowSel:hover{
    border: 2px solid #1890FF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
}
</style>
